import { Link } from 'react-router-dom';
import { AlertTriangle, Clock, CalendarClock } from 'lucide-react';
import type { CockpitHygiene } from '../../types';

export function HygienePanel({ data }: { data: CockpitHygiene }) {
  const items = [
    { icon: AlertTriangle, tone: 'text-rose-600 dark:text-rose-400', label: 'Overdue tasks', value: data.overdueTasks, to: '/activities' },
    { icon: Clock, tone: 'text-amber-600 dark:text-amber-400', label: 'Stale prospects (30d+)', value: data.staleProspects, to: '/people?stage=PROSPECT' },
    { icon: CalendarClock, tone: 'text-sky-600 dark:text-sky-400', label: 'Upcoming activities', value: data.upcomingActivities, to: '/activities' },
  ];
  return (
    <div className="card p-4 sm:p-6">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-3">Follow-up hygiene</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {items.map((it) => (
          <Link key={it.label} to={it.to} className="flex items-center gap-3 rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors">
            <it.icon className={`w-5 h-5 ${it.tone}`} />
            <div>
              <div className="text-xl font-bold tabular-nums text-gray-900 dark:text-gray-100">{it.value}</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">{it.label}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
